import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Careerpagebanner from '../components/Careerpagebanner'
import Cardsforopping from '../Careerpage/Cardsforopping'

function Career() {
  return (
    <div>
      <Header/>
      <Careerpagebanner/>
      <Cardsforopping/>
      <Footer/>
    </div>
  )
}

export default Career
